import { render, staticRenderFns } from "./addsubConfigTable.vue?vue&type=template&id=62f79f6b&scoped=true&"
import script from "./addsubConfigTable.vue?vue&type=script&lang=js&"
export * from "./addsubConfigTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f79f6b",
  null
  
)

export default component.exports